// extracted by mini-css-extract-plugin
export default {"startScreenContainer":"StartScreen_startScreenContainer__yLkhL"};